import {convertSpeedToMps} from '../../Units';

// see https://planetcalc.com/2089/
// see http://www.bom.gov.au/info/thermal_stress/?cid=003bl08#atapproximation
export default (
  t: number,
  rh: number,
  windspeed?: number,
  solarRadiation?: number,
) => {
  // Wind speed in m/s
  const ws = windspeed ? convertSpeedToMps(windspeed) : 0.0;

  const e = (rh / 100) * 6.105 * Math.exp((17.27 * t) / (237.7 + t));

  if (typeof solarRadiation !== 'undefined') {
    const Q = solarRadiation ? solarRadiation : 0.0;

    return t + 0.348 * e - 0.7 * ws + (0.7 * Q) / (ws + 10) - 4.25;
  } else {
    return t + 0.33 * e - 0.7 * ws - 4.0;
  }
};
